<template>
  <div class="table_box">
    <el-table
      ref="tableRef"
      :summary-method="getSummaries"
      show-summary
      size="small"
      :data="data"
      border
      style="width:100%"
      :height="max"
      class="tabone_sty"
      @row-dblclick="invalidRow"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'40px'}"
    >
      <el-table-column width="40" align="center" fixed="left">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-s-tools" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>

      <el-table-column fixed="left" label="操作" align="center" width="180">
        <template slot-scope="scope">
          <blockquote v-if="scope.row.ButtonType==1">
            <el-button @click.native.prevent="completeRow(scope.$index,scope.row)" type="text" size="small">强制完成</el-button>
            <el-button @click.native.prevent="copyRow(scope.$index,scope.row)" type="text" size="small">复制</el-button>
            <el-button @click.native.prevent="deleteRow(scope.$index,scope.row)" type="text" size="small">删除</el-button>
          </blockquote>
          <blockquote v-if="scope.row.ButtonType==2">
            <el-button @click.native.prevent="completeRow(scope.$index,scope.row)" type="text" size="small">强制完成</el-button>
            <el-button @click.native.prevent="copyRow(scope.$index,scope.row)" type="text" size="small">复制</el-button>
            <el-button @click.native.prevent="deleteRow(scope.$index,scope.row)" type="text" size="small" disabled>删除</el-button>
          </blockquote>    
          <blockquote v-if="scope.row.ButtonType==3">
            <el-button @click.native.prevent="completeRow(scope.$index,scope.row)" type="text" size="small" disabled>强制完成</el-button>
            <el-button @click.native.prevent="copyRow(scope.$index,scope.row)" type="text" size="small">复制</el-button>
            <el-button @click.native.prevent="deleteRow(scope.$index,scope.row)" type="text" size="small" disabled>删除</el-button>
          </blockquote>  
          <blockquote v-if="scope.row.ButtonType==4">
            <el-button @click.native.prevent="invalidRow(scope.row)" type="text" size="small">红冲作废</el-button>
            <el-button @click.native.prevent="copyRow(scope.$index,scope.row)" type="text" size="small">复制</el-button>
            <el-button @click.native.prevent="deleteRow(scope.$index,scope.row)" type="text" size="small" disabled>删除</el-button>
          </blockquote>
          <blockquote v-if="scope.row.ButtonType==5">
            <el-button @click.native.prevent="invalidRow(scope.row)" type="text" size="small" disabled>红冲作废</el-button>
            <el-button @click.native.prevent="copyRow(scope.$index,scope.row)" type="text" size="small">复制</el-button>
            <el-button @click.native.prevent="deleteRow(scope.$index,scope.row)" type="text" size="small" disabled>删除</el-button>
          </blockquote>
          <blockquote v-if="scope.row.ButtonType==6">
            <el-button @click.native.prevent="invalidRow(scope.row)" type="text" size="small" disabled>红冲作废</el-button>
            <el-button @click.native.prevent="copyRow(scope.$index,scope.row)" type="text" size="small" disabled>复制</el-button>
            <el-button @click.native.prevent="deleteRow(scope.$index,scope.row)" type="text" size="small" disabled>删除</el-button>
          </blockquote>   
          <blockquote v-if="scope.row.ButtonType==7">
            <el-button @click.native.prevent="copyRow(scope.$index,scope.row)" type="text" size="small">复制</el-button>
            <el-button @click.native.prevent="deleteRow(scope.$index,scope.row)" type="text" size="small">删除</el-button>
          </blockquote>
        </template>
      </el-table-column>
      <template v-for="(item,index) in ConfigData">
        <el-table-column :label="item.Rename" align="center" width="180" v-if="item.Key == 'Number' && item.Show == true" :key="index">
          <template slot-scope="scope">
            <el-button @click.native.prevent="invalidRow(scope.row)" type="text" size="small">{{scope.row[item.Key]}}</el-button>
          </template>
        </el-table-column>
        <el-table-column :label="item.Rename" :prop="item.Key" width="200" align="center" v-else-if="item.Key !== 'Number' && item.Show == true" :key="index">
          <template slot-scope="scope">
            <span class="span_inner_sty">{{scope.row[item.Key]}}</span>
          </template>
        </el-table-column> 
      </template>
    </el-table>
    <!-- table表格配置弹出框 -->
    <TableConfigDialog :show.sync="tableConfigShow" :tableData="ConfigData" v-bind="$attrs" v-on="$listeners" @restoreDefault="restoreDefault"/>
  </div>
</template>

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";
// 工具库
import tool from "@/utils/tool";

export default {
  data() {
    return {
      tableConfigShow: false, //配置项弹出框是否显示
      ConfigData: this.tableConfigData, //table配置项数据
      data:this.tableData,//表格数据项
      // searchData: { title: "", data: {}, type: "" }, //传递给选择单价与单位的弹出框,title:弹出框标题、data：传过去的数据、type：类型（单价选择、单位选择）
      pageList:[...dataConfig.pageList],
    };
  },
  props: {
    max: String,
    tableData: Array,
    tableConfigData: Array, //table配置项数据
  },
  methods: {
    // 点击红冲、单据编号、双击行
    invalidRow(data){
      if(!data.DataPriv.getone){
        this.$message({
            message: '您没有查看权限',
            type: 'warning'
        });
        return
      }
      let item = {
            title: this.findOrderName(data.VchType).pageName,
            component: this.findOrderName(data.VchType).pageRoute,
            menuId: 'draft' + 'invalidRow' + this.findOrderName(data.VchType).pageRoute + Math.random(),
            query:{}
          };
      // type：0：代表过草稿或新单（可填写）、1：代表过账或者已红冲（不可填写） dist:0为普通页面跳转过来的，1为红冲等跳转过来的，2为复制跳转过来的
      if(data.VchType == 7 ||data.VchType == 8){
        this.$tab.push(item, { VchCode: data.VchCode,VchType:data.VchType,type:data.Draft,dist:3});
      }else{
        this.$tab.push(item, { VchCode: data.VchCode,VchType:data.VchType,type:data.Draft,dist:1});
      }
    },
    // 点击复制
    copyRow(index,data){
      if(!data.DataPriv.getone && !data.DataPriv.copy){
        this.$message({
            message: '您没有复制权限',
            type: 'warning'
        });
        return
      }
      let item = {
            title: this.findOrderName(data.VchType).pageName,
            component: this.findOrderName(data.VchType).pageRoute,
            menuId: 'draft' + 'copyRow' + this.findOrderName(data.VchType).pageRoute + Math.random(),
            query:{}
          };
      this.$tab.push(item, { VchCode: data.VchCode,VchType:data.VchType,type:data.Draft,dist:2});
    },
    // 删除某张单据
    deleteRow(index,data){
      let params = {
          user_id:tool.getLocal("userid"),//用户ID
          session_id:tool.getLocal("sessionid"),//用户凭证
          VchCode:data.VchCode,//单据ID
      };
      this.request.post('/index.php/index/Delete_Bill/DeleteBill', {'jparams' : JSON.stringify(params)})
      .then(res => {
      // 接收后端发送回来的数据
          if(res.status==0){
              this.$message({
                  message: res.description,
                  type: 'success'
              });
              // 更新表格数据
              this.$emit('updateData')
          }else{
              this.$message({
                  message: '删除单据失败',
                  type: 'warning'
              });
          }
      })
      .catch(err => {
          console.log(err);
      });
    },
    // 点击强制完成
    completeRow(index,data){
      let params = {
          user_id:tool.getLocal("userid"),//用户ID
          session_id:tool.getLocal("sessionid"),//用户凭证
          VchCode:data.VchCode,//单据ID
      };
      this.request.post('/index.php/index/Force_Complete/ForceComplete', {'jparams' : JSON.stringify(params)})
      .then(res => {
      // 接收后端发送回来的数据
          if(res.status==0){
              this.$message({
                  message: res.description,
                  type: 'success'
              });
              // 更新表格数据
              this.$emit('updateData')
          }else{
              this.$message({
                  message: '删除单据失败',
                  type: 'warning'
              });
          }
      })
      .catch(err => {
          console.log(err);
      });
    },
    // 聚焦选中input全部
    inputFocus() {
      event.currentTarget.select();
    },
    
    //合计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        const values = data.map(item => {
          // if (
          //   column.property == "Total"||
          //   column.property == "QkTotal"||
          //   column.property == "SkTotal"||
          //   column.property == "YhTotal"//优惠金额
          // ) {
          //   if (Number(item[column.property]) != 'undefined') {
          //     // return Number(item[column.property]);
              return this.$attrs.footerMet[column.property]
          //   }
          // }
        });
        if (!values.every(value => isNaN(value))) {
          // sums[index] = this.sum(values);
          sums[index] = this.$attrs.footerMet[column.property]
          sums[index] += "";
        } else {
          // sums[index] = 'N/A';
        }
      });
      return sums;
    },
    // 累加数组中的number
    sum(arr) {
        var s = 0;
        for (var i=arr.length-1; i>=0; i--) {
            s += arr[i];
        }
        return Number(s).toFixed(2);
    },
    //点击图标事件
    clickIcon() {
      this.tableConfigShow = true;
    },
    // 恢复默认回调数据
    restoreDefault(data){
      this.ConfigData = data;
    },
    // 通过单据类型找到单据名称 nameType:route:路由名字 ，name：单据名称
    findOrderName(val){
      let pageInfor = this.pageList.find(item=>{
        return item.VchType == val
      })
      return pageInfor
    }
  },
  watch: {
    tableConfigData: {
      handler(newValue, oldValue) {
        this.ConfigData = newValue;
        this.data = this.tableData;
      },
      deep: true
    },
    tableData:{
      handler(newValue, oldValue) {
        this.data = this.tableData;
        this.$nextTick(()=>{
          this.$refs.tableRef.doLayout();
        })
      },
      deep: true
    },
  },
  computed: {},
};
</script>
<style lang="less">
// 引入样式
@import "./ProcessTable.less";
</style>


// WEBPACK FOOTER //
// src/components/Table/ProcessTable/ProcessTable.vue